import { isAndroid } from "react-device-detect";
import { GamingStorage } from "./gamingStorage";

export const loadImage = (
  src: string,
  timeout = 10000,
): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.crossOrigin = "anonymous";
    img.onload = function () {
      resolve(img);
    };

    setTimeout(() => {
      reject(img);
    }, timeout);

    img.onerror = function (err) {
      reject(err);
    };
  });

export class NativeShare {
  static share = async (data: ShareData) => {
    if (isAndroid && document?.fullscreenElement) {
      document?.exitFullscreen();
    }
    if (!window.navigator.canShare) {
      alert("Unsupported share feature");
      return;
    } else if (window.navigator.canShare(data)) {
      try {
        GamingStorage.setShareToMethod("nativeShare");
        const navigator = window.navigator;
        await navigator.share(data);
      } catch (e) {
        console.log(e);
        GamingStorage.getShareToMethod();
      }
    } else {
      alert("Specified data cannot be shared.");
      return;
    }
  };
}
